<template>
  <v-card
    dark
    color="#363636"
    class="client-list-item-card mx-4 my-4"
    width="200"
    ripple
    hover
  >
    <v-row style="background: #ffffff; width: 200px; height: 150px; margin: 0" justify="center" align="center">
      <v-img
        class="escudo-client"
        max-height="100"
        max-width="100"
        :src="getLogoUri(producer)"
      />
    </v-row>
    <v-card-subtitle color="white" class="pa-4 text-center" :style="{ whiteSpace: 'normal', wordWrap: 'break-word' }">
      {{ producer.data.display_name.toUpperCase() }}
    </v-card-subtitle>
    <v-card-actions>
      <v-btn
        class="mx-auto mb-2 px-12"
        variant="outlined"
        color="orange lighten-2"
        @click="() => lock(producer)"
      >
        Acessar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useProducerStore } from '@/stores/producer'
import { useRouter } from 'vue-router'
import Producer from '@/types/Producer'

const router = useRouter()

const { producer } = defineProps<{ producer: Producer }>()

function lock(producer: Producer) {
  useProducerStore().producer = producer
  router.push('/events')
}

function getLogoUri(producer: Producer) {
  return producer.images?.find(image => image.tag === 'producer-logo')?.url
}

</script>

<style lang="scss" scoped>
.client-list-item-subtitle {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
